var map = {
	"./am-photo-001.webp": 7805,
	"./am-photo-002.webp": 4903,
	"./am-photo-003.webp": 1129,
	"./am-photo-004.webp": 874,
	"./am-photo-005.webp": 2882,
	"./am-photo-006.webp": 8188,
	"./am-photo-007.webp": 4915,
	"./am-photo-008.webp": 3151,
	"./am-photo-009.webp": 8749,
	"./am-photo-010.webp": 242,
	"./am-photo-011.webp": 1319,
	"./am-photo-012.webp": 1051,
	"./am-photo-013.webp": 6797
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5318;